/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Fragment, useState } from 'react';
import PhoneNumberField from 'components/PhoneNumberField';
import FormField from 'vendor/Form/FormField';
import { idValidationStatuses } from '../../../../constants/idValidationStatuses';

function getGeneralFields(obj = {}) {
  const {
    first_name,
    surname,
    email,
    contact_number,
    id_number,
    id_file,
    contact_number_country,
    whatsapp_number,
    whatsapp_number_country,
    is_id_validated,
    id_disapproved,
  } = obj;
  const country_code = contact_number_country?.code;
  const whatsapp_country_code = whatsapp_number_country?.code;
  return {
    first_name,
    surname,
    email,
    country_code,
    contact_number,
    id_number,
    id_file,
    whatsapp_number,
    whatsapp_country_code,
    is_id_validated,
    id_disapproved,
  };
}

export default (values, diallingCodes) => {
  const generalFields = values ? getGeneralFields(values) : {};

  const TooltipText = ({ text }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const handleMouseEnter = () => {
      setShowTooltip(true);
    };

    const handleMouseLeave = () => {
      setShowTooltip(false);
    };

    return (
      <div
        className="relative inline-block w-1/2"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}>
        <img
          src="assets/images/tooltip.png"
          alt="Tooltip"
          className="ml-1 mb-3 md:mb-2 w-5 h-5"
        />
        {showTooltip && (
          <div className="absolute bg-black text-white py-1 px-2 rounded z-10 bottom-full left-10 md:left-0 -translate-x-1/2 -translate-y-2">
            {text}
          </div>
        )}
      </div>
    );
  };

  const renderBadge = () => {
    if (generalFields.id_disapproved === idValidationStatuses.PENDING) {
      return (
        <img
          src="assets/svgs/document-loading.svg"
          alt="Pending"
          className="ml-2 align-middle"
          width={16}
          height={16}
        />
      );
    }

    if (generalFields.is_id_validated) {
      return (
        <img
          src="assets/images/approved.png"
          alt="Approved"
          className="ml-2 align-middle"
        />
      );
    }

    if (generalFields.id_disapproved === idValidationStatuses.DISAPPROVED) {
      return (
        <TooltipText text="There was an error matching your ID number to your submitted ID document, please try again" />
      );
    }

    return null;
  };

  return [
    {
      fields: [
        {
          type: 'email',
          mandatory: true,
          name: 'email',
          label: 'Email',
          viewOnly: true,
          itemClass: 'form__item--horizontal',
          value: generalFields?.email || '',
        },
        {
          type: 'text',
          mandatory: true,
          name: 'first_name',
          label: 'First name',
          itemClass: 'form__item--horizontal',
          value: generalFields?.first_name || '',
        },
        {
          type: 'text',
          mandatory: true,
          name: 'surname',
          label: 'Surname',
          itemClass: 'form__item--horizontal',
          value: generalFields?.surname || '',
        },
        {
          type: 'component',
          mandatory: true,
          name: 'contact_number',
          label: 'Contact Number',
          value: '',
          component: (props) => (
            <Fragment>
              <div className="form__item--horizontal">
                <label htmlFor="contact_number" className="form__item__label">
                  Contact Number
                  {!props.viewOnly && props.mandatory && '*'}
                </label>
                <div className="text--dk--flushed form__item__input">
                  <PhoneNumberField
                    name="contact_number"
                    className="form__item--horizontal"
                    phoneNumber={generalFields?.contact_number}
                    countryCode={generalFields?.country_code}
                    countryCodeData={diallingCodes}
                    countryCodeVar="country_code"
                    phoneNumberVar="contact_number"
                    {...props}
                  />
                </div>
              </div>
            </Fragment>
          ),
        },
        {
          type: 'component',
          mandatory: false,
          name: 'whatsapp_number',
          label: 'WhatsApp Number',
          value: '',
          component: (props) => (
            <Fragment>
              <div className="form__item--horizontal">
                <label htmlFor="whatsapp_number" className="form__item__label">
                  WhatsApp Number
                  {!props.viewOnly && props.mandatory && '*'}
                </label>
                <div className="text--dk--flushed form__item__input">
                  <PhoneNumberField
                    name="whatsapp_number"
                    className="form__item--horizontal"
                    // show contact number as whatsapp number if whatsapp number is not set
                    phoneNumber={
                      generalFields?.whatsapp_number
                        ? generalFields?.whatsapp_number
                        : generalFields?.contact_number
                    }
                    countryCode={
                      generalFields?.whatsapp_country_code
                        ? generalFields?.whatsapp_country_code
                        : generalFields?.country_code
                    }
                    countryCodeVar="whatsapp_country_code"
                    phoneNumberVar="whatsapp_number"
                    countryCodeData={diallingCodes}
                    placeholder="WhatsApp Number"
                    {...props}
                  />
                </div>
              </div>
            </Fragment>
          ),
        },
        {
          type: 'component',
          mandatory: true,
          name: 'id_number',
          label: 'ID/Passport Number',
          itemClass: 'form__item--horizontal',
          component: ({ ...props }) => {
            const { id_disapproved, is_id_validated } = generalFields;

            if (
              is_id_validated === true ||
              id_disapproved === idValidationStatuses.PENDING
            ) {
              return (
                <Fragment>
                  <div className="form__item--horizontal">
                    <label htmlFor="id_file" className="form__item__label">
                      ID/Passport Number
                    </label>
                    <div className="text--dk--flushed form__item__input">
                      {renderBadge()}
                    </div>
                  </div>
                </Fragment>
              );
            }

            return (
              <FormField
                {...props}
                errorFields={props.errors}
                value={props.viewOnly ? generalFields?.id_number || '' : ''}
              />
            );
          },
        },
        {
          type: 'component',
          mandatory: true,
          name: 'id_file',
          component: ({ ...props }) => {
            const { id_disapproved, is_id_validated } = generalFields;

            if (
              is_id_validated === true ||
              id_disapproved === idValidationStatuses.PENDING
            ) {
              return null;
            }

            if (
              id_disapproved === idValidationStatuses.DISAPPROVED ||
              !is_id_validated
            ) {
              return (
                <Fragment>
                  <div className="form__item--horizontal">
                    <label htmlFor="id_file" className="form__item__label">
                      ID/Passport Document
                      {renderBadge()}
                      {!props.viewOnly && props.mandatory && '*'}
                    </label>
                    <div className="text--dk--flushed form__item__input">
                      <input
                        type="file"
                        id="id_file"
                        name="id_file"
                        onChange={(e) =>
                          props.controlRef('id_file', e.target.files[0])
                        }
                        disabled={props.viewOnly}
                      />
                    </div>
                  </div>
                </Fragment>
              );
            }

            return (
              <Fragment>
                <div className="form__item--horizontal">
                  <label htmlFor="id_file" className="form__item__label">
                    ID/Passport Document
                    {!props.viewOnly && props.mandatory && '*'}
                  </label>
                  <div className="text--dk--flushed form__item__input">
                    {generalFields.id_file ? (
                      <div className="file-upload-success">
                        {generalFields.id_file.split('/').pop()}
                      </div>
                    ) : (
                      <input
                        type="file"
                        id="id_file"
                        name="id_file"
                        onChange={(e) =>
                          props.controlRef('id_file', e.target.files[0])
                        }
                        disabled={props.viewOnly}
                      />
                    )}
                  </div>
                </div>
              </Fragment>
            );
          },
        },
      ],
    },
  ];
};
